import { Box, Container, Typography, IconButton } from "@mui/material";
import { ArrowBackIosNew } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { globalWordings } from "../data";

export const Navigation = ({ title, subtitle, backButton }) => {
  const navigate = useNavigate();
  const { lang } = useParams();

  return (
    <Box
      sx={{
        boxShadow: "0px -4px 20px 0px rgba(0, 0, 0, 0.30)",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          textAlign: "center",
          height: 105,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <Typography
          variant="heavy-bold"
          fontSize={lang === "en" ? 25 : 22}
          sx={{ textTransform: "uppercase" }}
        >
          {title}
        </Typography>
        <Typography
          variant="bold"
          fontSize={13}
          sx={{ textTransform: "uppercase" }}
        >
          {subtitle}
        </Typography>
        {backButton && (
          <Box
            sx={{ position: "absolute", left: 12 }}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <IconButton onClick={() => navigate(backButton)}>
              <ArrowBackIosNew color="primary" />
            </IconButton>

            <Typography
              variant="bold"
              fontSize={13}
              sx={{
                display: { xs: "none", md: "block" },
                cursor: "pointer",
              }}
              onClick={() => navigate(backButton)}
            >
              {globalWordings[lang].selectYourProduct}
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
};
